module.exports = __webpack_public_path__ + "static/media/icon_config_switch_lighting-1.052541be.svg";